import { render, staticRenderFns } from "./ManagementSite.vue?vue&type=template&id=39637780&scoped=true&"
import script from "./ManagementSite.vue?vue&type=script&lang=ts&"
export * from "./ManagementSite.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementSite.vue?vue&type=style&index=0&id=39637780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39637780",
  null
  
)

export default component.exports